import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";

import { IActivityManagementWorkflow } from "../../../../context/interfaces/IWorkflowContext";
import { IContent } from "../../interface/IActivitiesManagementModal";
import StatusPill from "../StatusPill/StatusPill";
import { ArrowRightIcon, CheckIcon } from "../../../../components/Icons";
import { StyledDefaultButtonLink } from "../../../../styles/pages/AcademicActivityPlanStyles";
import ActivitiesManagementModal from "../Modals/ActivitiesManagementModal/ActivitiesManagementModal";

import { useWorkflow } from "../../../../context/WorkflowContext";
import DialogMessageProps from "../../../../model/DialogMessageProps";
import DialogMessage from "../../../../components/DialogMessage";
import GenericUtils from "../../../../utils/GenericUtils";
import ActivityManagementWorkflowService from "../../../../service/Docente/ActivityManagementWorkflowService";
import { StyledFlexDiv } from "../../../../styles/MainStyles";

type ActivitiesManagementActionsProps = {
    workflow: IActivityManagementWorkflow;
};

interface IOpenActivitiesManagementModal {
    open: boolean;
    content: IContent;
}

const initialOpenActivitiesManagementModal: IOpenActivitiesManagementModal = {
    open: false,
    content: null,
};

const WORKFLOW_FILTER_STATUS = "AGUARDANDO_APROVACAO";

const ActivitiesManagementActions: React.FC<
    ActivitiesManagementActionsProps
> = ({ workflow }) => {
    const [openActivitiesManagementModal, setOpenActivitiesManagementModal] =
        useState<IOpenActivitiesManagementModal>(
            initialOpenActivitiesManagementModal
        );
    const [dialogMessageProps, setDialogMessageProps] =
        useState<DialogMessageProps>({} as DialogMessageProps);

    const { workflowFilter, filterWorkflows } = useWorkflow();
    const { instance } = useMsal();

    const handleCloseDialogMessage = () => {
        setDialogMessageProps({} as DialogMessageProps);
    };

    const handleOnCloseActivitiesManagementModal = () => {
        setOpenActivitiesManagementModal(initialOpenActivitiesManagementModal);
        filterWorkflows(workflowFilter);
    };

    const activitiesManagementModal = openActivitiesManagementModal.open && (
        <ActivitiesManagementModal
            open={openActivitiesManagementModal.open}
            workflow={workflow}
            initialContent={openActivitiesManagementModal.content}
            onClose={() => handleOnCloseActivitiesManagementModal()}
        />
    );

    const checkinPendencies = workflow.pendenciaCheckIn && (
        <StatusPill checkinPending={workflow.pendenciaCheckIn} />
    );

    const handleOpenActivitiesManagementModal = async (
        initialContent: IContent = null
    ) => {
        const response =
            await ActivityManagementWorkflowService.getExtractHoursWorkflow(
                workflowFilter.workflowTypeId,
                workflow.processoId,
                instance
            );

        if (GenericUtils.isSuccessStatus(response.status)) {
            if (!workflow.pendenciaCheckIn && initialContent === "FORMS")
                return;

            setOpenActivitiesManagementModal({
                open: true,
                content: initialContent,
            });
        } else {
            const dialogError = {
                ...GenericUtils.getPropsDialogError(response),
                onClose: handleCloseDialogMessage,
            };
            setDialogMessageProps(dialogError);
        }
    };

    const getHasPendencieColorIcon = () => {
        if (workflow.pendenciaCheckIn) return "#8A0538";

        return "#787878";
    };

    const dialogMessage = dialogMessageProps.show && (
        <DialogMessage
            type={dialogMessageProps.type}
            show={dialogMessageProps.show}
            title={dialogMessageProps.title}
            text={dialogMessageProps.text}
            onClose={dialogMessageProps.onClose}
        />
    );

    return (
        <>
            <StyledFlexDiv>
                {workflow.statusAprovacao === WORKFLOW_FILTER_STATUS ? (
                    <>
                        {checkinPendencies}
                        <StyledDefaultButtonLink
                            variant="link"
                            onClick={() =>
                                handleOpenActivitiesManagementModal()
                            }
                        >
                            <CheckIcon style={{ fill: "#8A0538" }} />
                            Analisar Fechamento
                        </StyledDefaultButtonLink>
                    </>
                ) : (
                    <>
                        <StatusPill status="CONCLUIDO" />
                        <StyledDefaultButtonLink
                            variant="link"
                            onClick={() => {
                                handleOpenActivitiesManagementModal("FORMS");
                            }}
                            disabled={!workflow.pendenciaCheckIn}
                        >
                            <ArrowRightIcon
                                style={{ fill: getHasPendencieColorIcon() }}
                            />
                            Ver Check-ins
                        </StyledDefaultButtonLink>
                        <StyledDefaultButtonLink
                            variant="link"
                            onClick={() => {
                                handleOpenActivitiesManagementModal("SUMMARY");
                            }}
                        >
                            <CheckIcon style={{ fill: "#8A0538" }} />
                            Ver Extrato
                        </StyledDefaultButtonLink>
                    </>
                )}
            </StyledFlexDiv>
            {activitiesManagementModal}
            {dialogMessage}
        </>
    );
};

export default ActivitiesManagementActions;
